import React from "react";
import { graphql } from "gatsby";
import NavHeader from "../components/nav-header";
import StandardPage from "../components/standard-page";
import StandardSection from "../components/standard-section";
import Seo from "../components/seo";
import ContentRender from "../components/content-render";

export default function Tos({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const frontmatter = data.file.childMdx.frontmatter;

  return (
    <StandardPage header={<NavHeader />}>
      <StandardSection title={frontmatter?.title}>
        <ContentRender className="space-y-8">
          {data.file.childMdx.body}
        </ContentRender>
      </StandardSection>
      <Seo title={frontmatter?.title} slug="/tos/" type={false} />
    </StandardPage>
  );
}

export const pageQuery = graphql`
  query {
    file(relativePath: { eq: "policy/tos.md" }) {
      childMdx {
        body
        frontmatter {
          title
        }
      }
    }
  }
`;
